import React from 'react'
import CommonAudio from 'common/components/entities/Audio/AudioNew'
import { AudioInterface } from 'common/types/entities/AudioInterface'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'

function AudioNew({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<AudioInterface>) {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonAudio htmlAttrId={entity.htmlAttrId} />
    </BaseEntityNew>
  )
}

export default AudioNew
